/**
 * Created by baird on 2016/12/30.
 */

/*
 * 全局布局控制
 * */
export const Layout = {
    CHANGE_MENU_FIXED: 'CHANGE_MENU_FIXED',
    CHANGE_MENU_SHOW: 'CHANGE_MENU_SHOW',
    CHANGE_TOP_BAR: 'CHANGE_TOP_BAR'

};


/*页面*/
export const PAGE_UPDATA_STATE = 'PAGE_UPDATA_STATE';
export const DIYFORM_UPDATA_STATE = 'DIYFORM_UPDATA_STATE';


/*
 * 用户
 * */
export const ACCOUNT_CACTE_STATE = 'ACCOUNT_CACTE_STATE';
export const ACCOUNT_UPDATE_TOKEN = 'ACCOUNT_UPDATE_TOKEN';
export const ACCOUNT_DOLOGIN = 'ACCOUNT_CACTE_STATE';
export const ACCOUNT_UPDATE_PROFILE = 'ACCOUNT_UPDATE_PROFILE';

/**
 * 主题
 */

export const Theme = {
    CHANGE_THEME: 'CHANGE_THEME'
};
/**
 * 患者信息
 */
export const Person = {
    CHANGE_PERSON: 'CHANGE_PERSON'
};



// WEBPACK FOOTER //
// ./src/store/mutation.js